import {observer} from "mobx-react";

import * as S from './styles'
import {FormattedMessage} from "react-intl";

import NotebookImage1 from '../../../assets/images/m_cnt4_notebook1.png';


export const Content4 = observer(() => {

    return (
        <S.Container>
            <S.Content>
                <div>
                    <S.Notebook src={NotebookImage1}/>
                </div>
                <div>
                    <S.Line1>
                        <S.Text>
                            <span><FormattedMessage id="notebookText1"/></span>
                        </S.Text>
                    </S.Line1>
                    <S.Line2>
                        <S.Text>
                            <span><FormattedMessage id="notebookText2"/></span>
                        </S.Text>
                    </S.Line2>
                    <S.Line3>
                        <S.Text>
                            <span><FormattedMessage id="notebookText3"/></span>
                        </S.Text>
                    </S.Line3>
                    <S.Line4>
                        <S.Text>
                            <span><FormattedMessage id="notebookText4"/></span>
                        </S.Text>
                    </S.Line4>
                    <S.Line5>
                        <S.Text>
                            <span><FormattedMessage id="notebookText5"/></span>
                        </S.Text>
                    </S.Line5>
                </div>
            </S.Content>
        </S.Container>
    )
})
